export const name = 'minus';

export const Minus = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.07001 9.5H15.93"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
  </svg>
);
